"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const textService = (sdk) => {
    const { sdkConfig: { url }, httpClient, } = sdk;
    return {
        getFederalStates: async () => {
            const endpoint = `${url}/v3/texts/federalStates`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPublishers: async () => {
            const endpoint = `${url}/v3/texts/publishers`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getSchoolStages: async () => {
            const endpoint = `${url}/v3/texts/schoolStages`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getSchoolTypes: async () => {
            const endpoint = `${url}/v3/texts/schoolTypes`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        // SEAR-460: canonical AI filter values for the `useAiFilters` flag-on
        // cohort, proxied by APIv3 from kimuno's /search/filter-values.
        getAiFilterValues: async () => {
            const endpoint = `${url}/v3/texts/aiFilterValues`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getWorkloads: async () => {
            const endpoint = `${url}/v3/texts/workloads`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getTeachingFormats: async () => {
            const endpoint = `${url}/v3/texts/teachingFormats`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getTeacherRoles: async () => {
            const endpoint = `${url}/v3/texts/teacherRoles`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getSchools: async (payload) => {
            var _a;
            const endpoint = `${url}/v3/texts/schoolDetails`;
            try {
                const response = await httpClient.post(endpoint, {
                    payload: Object.assign(Object.assign({}, payload), { includedType: 'school', strictTypeFiltering: true, languageCode: 'de' }),
                });
                return (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : [];
            }
            catch (error) {
                throw new Error('Failed to fetch school details');
            }
        }
    };
};
exports.default = textService;
